import React, { useState, useEffect } from "react";
import { EditOutlined, DeleteOutlined, LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import {
  theme,
  ConfigProvider,
  Row,
  Typography,
  Col,
  Card,
  Breadcrumb, FloatButton, Spin
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/layouts/MainLayout";
// import FloatButtonComp from "../../../../components/FloatButtonComp";
import { OfficesToChargesAndFeesForm } from "./components/OfficesToChargesAndFeesForm";
import { RolesToLPForm } from "./components/RolesToLPForm";
import { RolesToCASAForm } from "./components/RolesToCASAForm";
import { OfficesToCASAForm } from "./components/OfficesToCASAForm";
import tabList from "./components/tabList.json";
import { OfficesToLPForm } from "./components/OfficesToLPForm";
import CustomButton from "./components/customButton";

// const { Content } = Layout;
const { Text, Title, } = Typography;
// const { Panel } = Collapse;


const SYA1700 = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/prd0200");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#2F172D");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
      >
        <MainPage titleOfPage={"Entity Mapping"} />
      </MainLayout>
    </ConfigProvider>
  );
};


function MainPage(props) {
  // const navigate = useNavigate();
  const [editing, setEditing] = useState(true); // This is reffering to the 'disabled' API of the the Text Boxes, etc. True means that 'disabled' = true.

  // function backOnClick() {
  //   navigate("/prd0200", { replace: true });
  // }



  function HandleEditClick() {
    if (editing === true) {
      setEditing(false);
    } else {
      setEditing(true);
    }
  }

  function onEditModeCancel() {
    setEditing(true);
  }


  return (
    <div style={{ marginBottom: 50 }}>
      {/* <FloatButtonGroup onEditClick={HandleEditClick} /> */}
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginBottom: 25,
        }}>
        <Col>
          <Row style={{ marginBottom: 0, marginTop: 0 }}>
            <Title level={2} style={{ margin: 0 }}>
              {props.titleOfPage}
            </Title>
          </Row>
          <Breadcrumb style={{ marginBottom: 0 }}>
            <BreadcrumbItem>
              <Link to="/dashboard">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Text>Entity Mapping</Text>
            </BreadcrumbItem>
          </Breadcrumb>
        </Col>

      </Card>
      <div>
        <EntityMappingTabs
          disabled={editing}
          onEditCancel={onEditModeCancel}
          formButtonState={editing} />
      </div>
    </div>
  )
}

function EntityMappingTabs(props) {
  const navigate = useNavigate();
  const [activeTabKey, setActiveTabKey] = useState("officesToLoanProducts");
  const [loading, setLoading] = useState(true);

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  useEffect(() => {
    // Simulate an API call or data fetching
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  function onCancel() {
    navigate("/prd0200", { replace: false });
  }

  const contentListNoTitle = {
    officesToLoanProducts: (<>
      <OfficesToLPForm
        disabled={props.disabled}
        onEditCancel={props.onEditCancel}
        formButtonState={props.formButtonState}
      />
      {!props.formButtonState && <CustomButton onCancel={onCancel} />}
    </>
    ),

    officesToSavingsProducts: (
      <>
        <OfficesToCASAForm
          disabled={props.disabled}
          onEditCancel={props.onEditCancel}
          formButtonState={props.formButtonState}
        />
        {!props.formButtonState && <CustomButton onCancel={onCancel} />}
      </>
    ),
    officesToChargesAndFees: (
      <>
        <OfficesToChargesAndFeesForm
          disabled={props.disabled}
          onEditCancel={props.onEditCancel}
          formButtonState={props.formButtonState}
        />
        {!props.formButtonState && <CustomButton onCancel={onCancel} />}
      </>
    ),
    rolesToLoanProducts: (
      <>
        <RolesToLPForm
          disabled={props.disabled}
          onEditCancel={props.onEditCancel}
          formButtonState={props.formButtonState}
        />
        {!props.formButtonState && <CustomButton onCancel={onCancel} />}

      </>
    ),
    rolesToSavingsProducts: (
      <>
        <RolesToCASAForm
          disabled={props.disabled}
          onEditCancel={props.onEditCancel}
          formButtonState={props.formButtonState}
        />
        {!props.formButtonState && <CustomButton onCancel={onCancel} />}

      </>
    )
  };

  return (
    <Spin spinning={loading}>
      <Card
        style={{
          width: "100%",
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        tabList={tabList}
        activeTabKey={activeTabKey}
        onTabChange={onTabChange}
        tabProps={{
          size: "middle",
        }}
      >
        {contentListNoTitle[activeTabKey]}
      </Card>
    </Spin>
  );
}

export default SYA1700;
